import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/assets";
import { LayoutDashboard, Users, FileText, Film, Sparkles, Calendar, MessageSquare, HelpCircle, CreditCard, Ticket, Mail, Settings, LogOut, Newspaper, Package, BarChart3 } from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/reports", label: "Reports", icon: BarChart3, adminOnly: true },
  { to: "/admin/members", label: "Members", icon: Users, adminOnly: true },
  { to: "/admin/blog", label: "Blog Posts", icon: FileText },
  { to: "/admin/videos", label: "Videos", icon: Film },
  { to: "/admin/series", label: "Five Takeaways", icon: Sparkles },
  { to: "/admin/events", label: "Events", icon: Calendar },
  { to: "/admin/requests", label: "Speaking Requests", icon: MessageSquare },
  { to: "/admin/press", label: "Press Materials", icon: Newspaper },
  { to: "/admin/resources", label: "Resources", icon: Package },
  { to: "/admin/questions", label: "Q&A Submissions", icon: HelpCircle },
  { to: "/admin/plans", label: "Membership Plans", icon: Ticket },
  { to: "/admin/payments", label: "Payments", icon: CreditCard, adminOnly: true },
  { to: "/admin/discounts", label: "Discount Codes", icon: Ticket, adminOnly: true },
  { to: "/admin/subscribers", label: "Subscribers", icon: Mail, adminOnly: true },
  { to: "/admin/settings", label: "Settings", icon: Settings, adminOnly: true },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const nav2 = useNavigate();
  const doLogout = async () => { await logout(); nav2("/"); };
  const visible = nav.filter(n => !n.adminOnly || user?.role === "admin");
  return (
    <div className="admin-shell">
      <aside className="fixed top-0 left-0 w-64 h-screen bg-plum text-cream p-6 hidden lg:flex flex-col z-30 overflow-y-auto">
        <Link to="/"><img src={LOGO_URL} alt="Judge Auntie Says" className="h-16 mb-4 w-auto object-contain" /></Link>
        <div className="text-xs uppercase tracking-widest text-gold mb-3">Admin</div>
        <nav className="flex flex-col gap-1">
          {visible.map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({isActive}) => `admin-sidebar-link ${isActive ? "active" : ""}`} data-testid={`admin-nav-${n.to.split("/").pop()}`}>
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto pt-6 border-t border-cream/10">
          <div className="text-sm">{user?.name}</div>
          <div className="text-xs text-cream/60 truncate">{user?.email}</div>
          <button onClick={doLogout} className="mt-4 flex items-center gap-2 text-sm text-cream/70 hover:text-cream" data-testid="admin-logout">
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>
      <div className="lg:ml-64 min-h-screen">
        <header className="bg-cream border-b border-gold-light lg:hidden">
          <div className="px-6 py-4 flex items-center justify-between">
            <Link to="/"><img src={LOGO_URL} className="h-12 w-auto object-contain" alt="Judge Auntie Says" /></Link>
            <button onClick={doLogout} className="text-sm text-plum" data-testid="admin-logout-mobile">Sign out</button>
          </div>
        </header>
        <div className="lg:hidden bg-plum text-cream px-6 py-3 overflow-x-auto whitespace-nowrap">
          {visible.map(n => (
            <NavLink key={n.to} to={n.to} end={n.end} className={({isActive}) => `inline-block px-3 py-1.5 mr-2 rounded-full text-xs ${isActive ? "bg-gold text-plum" : "text-cream/80"}`}>
              {n.label}
            </NavLink>
          ))}
        </div>
        <main className="p-6 md:p-10">{children}</main>
      </div>
    </div>
  );
}
